import React, { useEffect, useState } from 'react';
import { CheckIcon } from './icons/CheckIcon';
const features = ['Acceso inmediato al Master completo', 'Más de 30 lecciones en video HD', 'Material descargable (PDFs, plantillas, guías)', 'Certificado de finalización profesional', 'Acceso de por vida + actualizaciones', 'Soporte directo con la instructora', '7 bonos exclusivos (valor $197 USD)'];
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    // Set countdown to 24 hours from now
    const calculateTimeLeft = () => {
      const now = new Date().getTime();
      const endTime = now + 24 * 60 * 60 * 1000; // 24 hours from now
      // Store end time in localStorage to persist across page reloads
      const storedEndTime = localStorage.getItem('countdownEndTime');
      const targetTime = storedEndTime ? parseInt(storedEndTime) : endTime;
      if (!storedEndTime) {
        localStorage.setItem('countdownEndTime', targetTime.toString());
      }
      const difference = targetTime - now;
      if (difference > 0) {
        return {
          hours: Math.floor(difference / (1000 * 60 * 60) % 24),
          minutes: Math.floor(difference / 1000 / 60 % 60),
          seconds: Math.floor(difference / 1000 % 60)
        };
      }
      return {
        hours: 0,
        minutes: 0,
        seconds: 0
      };
    };
    setTimeLeft(calculateTimeLeft());
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  const handleAddToCart = () => {
    // Fire Facebook Pixel AddToCart event
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Master Hydra Gloss Lips 2.0',
        content_ids: ['47717496684792'],
        content_type: 'product',
        value: 27.0,
        currency: 'USD'
      });
    }
    // Redirect to Shopify cart
    window.location.href = 'https://shop.hydraglosslips.com/cart/47717496684792:1';
  };
  return <section id="precio" className="py-12 px-4 bg-[#FDFBF7]" data-id="element-228">
      <div className="max-w-4xl mx-auto" data-id="element-229">
        {/* Countdown Timer */}
        <div className="text-center mb-8" data-id="element-230">
          <div className="inline-block bg-gradient-to-r from-[#E5A5A0] to-[#D4AF7A] text-white px-4 py-1.5 rounded-full text-xs font-semibold mb-4 shadow-sm" data-id="element-231">
            ⚡ OFERTA POR TIEMPO LIMITADO
          </div>

          <h2 className="text-2xl md:text-3xl font-semibold text-[#3D3028] mb-3" data-id="element-232">
            Esta oferta expira en:
          </h2>

          {/* Countdown Display */}
          <div className="flex justify-center gap-3 md:gap-4 mb-6" data-id="element-233">
            {/* Hours */}
            <div className="bg-white rounded-xl shadow-lg border border-[#D4C4B0]/20 p-3 md:p-4 min-w-[70px] md:min-w-[90px]" data-id="element-234">
              <div className="text-3xl md:text-4xl font-bold text-[#3D3028] tabular-nums" data-id="element-235">
                {formatNumber(timeLeft.hours)}
              </div>
              <div className="text-[10px] md:text-xs text-[#3D3028]/60 font-medium mt-1 uppercase tracking-wide" data-id="element-236">
                Horas
              </div>
            </div>

            {/* Separator */}
            <div className="flex items-center text-2xl md:text-3xl font-bold text-[#E5A5A0]" data-id="element-237">
              :
            </div>

            {/* Minutes */}
            <div className="bg-white rounded-xl shadow-lg border border-[#D4C4B0]/20 p-3 md:p-4 min-w-[70px] md:min-w-[90px]" data-id="element-238">
              <div className="text-3xl md:text-4xl font-bold text-[#3D3028] tabular-nums" data-id="element-239">
                {formatNumber(timeLeft.minutes)}
              </div>
              <div className="text-[10px] md:text-xs text-[#3D3028]/60 font-medium mt-1 uppercase tracking-wide" data-id="element-240">
                Minutos
              </div>
            </div>

            {/* Separator */}
            <div className="flex items-center text-2xl md:text-3xl font-bold text-[#E5A5A0]" data-id="element-241">
              :
            </div>

            {/* Seconds */}
            <div className="bg-white rounded-xl shadow-lg border border-[#D4C4B0]/20 p-3 md:p-4 min-w-[70px] md:min-w-[90px]" data-id="element-242">
              <div className="text-3xl md:text-4xl font-bold text-[#3D3028] tabular-nums" data-id="element-243">
                {formatNumber(timeLeft.seconds)}
              </div>
              <div className="text-[10px] md:text-xs text-[#3D3028]/60 font-medium mt-1 uppercase tracking-wide" data-id="element-244">
                Segundos
              </div>
            </div>
          </div>

          <p className="text-sm text-[#3D3028]/70" data-id="element-245">
            Después de este tiempo, el precio volverá a{' '}
            <span className="font-semibold" data-id="element-246">$297 USD</span>
          </p>
        </div>

        {/* Pricing Card */}
        <div className="bg-white rounded-2xl p-6 md:p-10 border-2 border-[#E5A5A0] shadow-xl relative overflow-hidden" data-id="element-247">
          {/* Best Value Badge */}
          <div className="absolute top-0 right-0 bg-gradient-to-r from-[#E5A5A0] to-[#D4AF7A] text-white px-6 py-2 text-xs font-semibold shadow-lg transform rotate-0 translate-x-0 translate-y-0 rounded-bl-2xl" data-id="element-248">
            MEJOR OFERTA
          </div>

          <div className="text-center mb-8 pt-4" data-id="element-249">
            <h3 className="text-xl md:text-2xl font-semibold text-[#3D3028] mb-4" data-id="element-250">
              MASTER HYDRA GLOSS LIPS™ 2.0
            </h3>

            <div className="space-y-2" data-id="element-251">
              <div className="flex items-center justify-center gap-3" data-id="element-252">
                <span className="text-2xl md:text-3xl text-[#3D3028]/40 line-through" data-id="element-253">
                  $297 USD
                </span>
                <span className="bg-[#E5A5A0] text-white px-3 py-1 rounded-full text-sm font-semibold" data-id="element-254">
                  -91% OFF
                </span>
              </div>

              <div className="text-5xl md:text-6xl font-bold text-[#3D3028]" data-id="element-255">
                $27 USD
              </div>

              <p className="text-sm text-[#3D3028]/60" data-id="element-256">
                Pago único • Acceso de por vida
              </p>
            </div>
          </div>

          {/* Features List */}
          <div className="space-y-3 mb-8" data-id="element-257">
            {features.map((feature, index) => <div key={index} className="flex items-start gap-3" data-id="element-258">
                <div className="flex-shrink-0 w-5 h-5 bg-[#E5A5A0]/10 rounded-full flex items-center justify-center mt-0.5" data-id="element-259">
                  <CheckIcon className="w-3 h-3 text-[#E5A5A0]" data-id="element-260" />
                </div>
                <span className="text-[#3D3028]/80 text-sm md:text-base leading-snug" data-id="element-261">
                  {feature}
                </span>
              </div>)}
          </div>

          {/* CTA Button */}
          <button onClick={handleAddToCart} className="block w-full bg-[#E5A5A0] hover:bg-[#d99590] text-white text-center px-8 py-4 rounded-full text-base md:text-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-[1.02]" data-id="element-262">
            INSCRIBIRME AHORA
          </button>

          <p className="text-center text-xs text-[#3D3028]/60 mt-4" data-id="element-263">
            🔒 Pago seguro • Garantía de 7 días
          </p>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center gap-4 mt-8 text-xs text-[#3D3028]/60" data-id="element-264">
          <div className="flex items-center gap-2" data-id="element-265">
            <svg className="w-4 h-4 text-[#E5A5A0]" fill="currentColor" viewBox="0 0 20 20" data-id="element-266">
              <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-267" />
            </svg>
            <span data-id="element-268">Pago 100% seguro</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-269">
            <svg className="w-4 h-4 text-[#E5A5A0]" fill="currentColor" viewBox="0 0 20 20" data-id="element-270">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-271" />
            </svg>
            <span data-id="element-272">Acceso inmediato</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-273">
            <svg className="w-4 h-4 text-[#E5A5A0]" fill="currentColor" viewBox="0 0 20 20" data-id="element-274">
              <path d="M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" data-id="element-275" />
              <path d="M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1V5a1 1 0 00-1-1H3zM14 7a1 1 0 00-1 1v6.05A2.5 2.5 0 0115.95 16H17a1 1 0 001-1v-5a1 1 0 00-.293-.707l-2-2A1 1 0 0015 7h-1z" data-id="element-276" />
            </svg>
            <span data-id="element-277">Garantía de 7 días</span>
          </div>
        </div>
      </div>
    </section>;
}